import { render, staticRenderFns } from "./ListaMovimientosTodosAceptadosPorPaciente.vue?vue&type=template&id=0057e46d"
import script from "./ListaMovimientosTodosAceptadosPorPaciente.vue?vue&type=script&lang=js"
export * from "./ListaMovimientosTodosAceptadosPorPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports